import React from "react";
import ReactDOM from "react-dom";

import _str from "shared/util/_str";
import ModalReport, { MODAL_ID } from "shared/components/ModalReport";

// modal types. this also gets sent to the backend as `type`
export const TYPES = {
	MESSAGE: "message",
	PROFILE: "profile",
	PHOTO: "photo",
	PHOTO_ALBUM: "photo_album",
};

export const TYPE_IDS = {
	[TYPES.MESSAGE]: 12,
	[TYPES.PROFILE]: 1,
	[TYPES.PHOTO]: 0,
	[TYPES.PHOTO_ALBUM]: 13,
};

export const TITLES = {
	[TYPES.MESSAGE]: _str("Report a message"),
	[TYPES.PROFILE]: _str("Report a person"),
	[TYPES.PHOTO]: _str("Report a photo"),
	[TYPES.PHOTO_ALBUM]: _str("Report a photo"),
};

export const REASONS = {
	[TYPES.MESSAGE]: [
		{
			text: _str("Aggressive / Harassment"),
			value: "1",
		},
		{
			text: _str("Sexual harassment"),
			value: "2",
		},
		{
			text: _str("Spammer / Scammer / Fake"),
			value: "3",
		},
		{
			text: _str("Minor (under 18 years old)"),
			value: "4",
		},
		{
			text: _str("Offsite behavior: Assault / Abuse / Violence"),
			value: "5",
		},
		{
			text: _str("Other"),
			value: "6",
		},
	],
	[TYPES.PROFILE]: [
		{
			text: _str("Aggressive / Harassment"),
			value: "1",
		},
		{
			text: _str("Sexual harassment"),
			value: "2",
		},
		{
			text: _str("Not who I’m looking for"),
			value: "11",
		},
		{
			text: _str("Spammer / Scammer / Fake"),
			value: "3",
		},
		{
			text: _str("Minor (under 18 years old)"),
			value: "4",
		},
		{
			text: _str("Offsite behavior: Assault / Abuse / Violence"),
			value: "5",
		},
		{
			text: _str("Other"),
			value: "6",
		},
	],
	[TYPES.PHOTO]: [
		{
			text: _str("Offensive"),
			value: "7",
		},
		{
			text: _str("Nudity"),
			value: "8",
		},
		{
			text: _str("Not the person"),
			value: "9",
		},
		{
			text: _str("Other"),
			value: "10",
		},
	],
	[TYPES.PHOTO_ALBUM]: [
		{
			text: _str("Offensive"),
			value: "7",
		},
		{
			text: _str("Nudity"),
			value: "8",
		},
		{
			text: _str("Other"),
			value: "10",
		},
	],
};

/**
 * The controller that mounts and opens the modal.
 *
 * @name Report
 * @global
 */
const Report = {
	/**
	 * Creates the modal mount node and appends it to the page.
	 *
	 * @method
	 * @param {Boolean} shouldOpen - Whether or not to open immediately.
	 * @param {Object} options - Passed down to open in case of shouldOpen = true.
	 */
	init(shouldOpen = false, options) {
		if (!this.$el) {
			this.$el = document.createElement("div");
			this.$el.id = MODAL_ID;
			document.body.appendChild(this.$el);
		}

		if (shouldOpen) {
			this.open(options);
		}
	},

	/**
	 * Closes the modal. In this case that means unmounting the React component.
	 * It really shouldn't be this way, but we kind of have to because this is a
	 * standalone component, it's not part of a larger app that can maintain an
	 * open/close state.
	 *
	 * @method
	 */
	close() {
		// run this in another thread (otherwise React will complain,
		// because we're running this in an event handler, and the element is removed
		// AFTER the event is handled. yeah i don't really understand either)
		requestAnimationFrame(() => {
			ReactDOM.unmountComponentAtNode(this.$el);
		});
	},

	/**
	 * Opens the React component. If the mount node isn't there, this method will
	 * call init to add it to the page and then run the open method again. It
	 * should just work every time you call it. All properties on the params
	 * object are required.
	 *
	 * @method
	 * @param {Object} params - An object of parameters
	 * @param {string} params.type - The type of flag modal (message/profile/photo)
	 * @param {String} params.userid - the target's userid
	 * @param {String} params.msgid - ID of the message
	 * @param {String} params.threadid - ID of the thread. When threadid is
	 *   provided, msgid is not needed. Use threadid so flagged threads show up
	 *   correctly in HRT.
	 */
	open(params = {}) {
		if (!params.userid) {
			console.error("Report must be called with a userid!");
			return;
		}

		if (!params.type) {
			console.error("Report must be called with a type!");
			return;
		}

		if (!this.$el) {
			this.init(true, params);
			return;
		}

		ReactDOM.render(<ModalReport {...params} />, this.$el);
	},
};


/**
 * Exports the report message singleton. Call open with the parameters of the
 * user you want to flag a message for.
 *
 * @exports {Object} Report
 */
export default Report;



// WEBPACK FOOTER //
// ./src/shared/util/Report.js